import React, {Component} from 'react'
import {LinkBox} from '../LinkBox'
import {Title} from '../Title'
import {Grid} from '../Grid'

import './link-box-grid.css'

const nCellsPerRowMobile = 2;

class LinkBoxGrid extends Component {

  render() {
    let data = this.props.data.map(
      (datum, index) =>
        <LinkBox fixedWidth={'100%'} data = {datum}></LinkBox>
      );

    return (
      <div>
        <Grid
          marginTop = {33}
          data = {data}
          nCellsPerRow = {this.props.nCellsPerRow}
          nCellsPerRowMobile = {nCellsPerRowMobile}>
        </Grid>
      </div>
    );
  }
}

export default {LinkBoxGrid}



// WEBPACK FOOTER //
// ./src/components/LinkBoxGrid/index.js